import { render, staticRenderFns } from "./Vansales.vue?vue&type=template&id=4cf51661&scoped=true"
import script from "./Vansales.vue?vue&type=script&lang=js"
export * from "./Vansales.vue?vue&type=script&lang=js"
import style0 from "./Vansales.vue?vue&type=style&index=0&id=4cf51661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf51661",
  null
  
)

export default component.exports